<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" data-title="SNS 회원가입" ref="header" :type="'empty'"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <div class="progress">
          <ol>
            <li><span>약관동의</span></li>
            <li><span>정보입력</span></li>
            <li class="on"><span>정보 입력(선택)</span></li>
          </ol>
        </div>

        <section class="hr">
          <div class="titArea">
            <h2 class="titH3 normal">선택 정보 입력</h2>
            <p class="desc">
              맞춤 상품을 추천하기 위한 선택 정보입니다. 입력을 원치 않으시면 바로 “가입 완료” 버튼을 눌러주세요.
            </p>
          </div>

          <p class="choiceTit mb0">
            <strong>평소 관심이 있으신 상품을 선택해주세요</strong>
            <span class="txtS">(중복선택가능)</span>
          </p>
          <ul class="iptGroup div_2 giftChoice">
            <li v-for="(item, index) in cus1Items" :key="index">
              <input type="checkbox" class="ipt" name="chk1" :id="'chk1_' + index" :value="item.bsnId + item.bsnVal" v-model="products" />
              <label :for="'chk1_' + index">
                <!-- <span class="img"><img src="@/../static/img/mw/content/img_gift1.png" /></span> -->
                <span class="img"><img :src="item.imgUrl" /></span>
                <span>{{ item.bsnName }}</span>
              </label>
            </li>
          </ul>
          <p class="choiceTit"><strong>고객님의 성별을 골라주세요</strong></p>
          <ul class="iptGroup iptBtn">
            <li v-for="(item, index) in cus2Items" :key="index">
              <input type="radio" class="ipt" name="rdo1" :id="'rdo1_' + index" :value="item.code" v-model="request.userInfo.sex" />
              <label :for="'rdo1_' + index">
                <span class="ico">{{ item.codeName }}</span>
              </label>
            </li>
          </ul>
          <p class="choiceTit">
            <strong>고객님의 가족 구성은 어떤 형태인가요?</strong>
          </p>
          <ul class="iptGroup iptBtn div_2">
            <!-- class="brtl brt brbl brbr" -->
            <li v-for="(item, index) in cus3Items_first" :key="index" :class="{ brtl: index == 0, brtr: index == 1 }">
              <input type="radio" class="ipt" name="rdo2" :id="'rdo2_' + index" :value="item.bsnId + item.bsnVal" v-model="family" />
              <label :for="'rdo2_' + index">
                <span class="ico">{{ item.bsnName }}</span>
              </label>
            </li>
            <li class="brbl brbr" v-for="(item, index) in cus3Items_last" :key="'cus3Items_last' + index">
              <input type="checkbox" class="ipt" name="chkpet1" id="chkpet1" v-model="pet" />
              <label for="chkpet1">
                <span class="ico">{{ item.bsnName }}</span>
              </label>
            </li>
          </ul>
          <div class="btnArea sticky">
            <button type="button" class="btn_p" @click="snsJoin">가입완료</button>
          </div>
        </section>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
  </div>
  <!-- wrapper(e) -->
</template>
<script>
import ApiService from '@/common/api.service';
import { SET_JOIN_INFO } from '@/store/mutations.type';

export default {
  name: 'snsJoinStep3',
  async mounted() {
    this.param = this.$route.params.request;
    this.$store.commit(SET_JOIN_INFO, this.param);
    // console.log(this.$route);
    // console.log(this.param);

    this.request.agreeInfo.agreeAppPush = this.param.agreeInfo.agreeAppPush;
    this.request.agreeInfo.agreeCollection = this.param.agreeInfo.agreeCollection;
    this.request.agreeInfo.agreeCredit = this.param.agreeInfo.agreeCredit;
    this.request.agreeInfo.agreeDm = this.param.agreeInfo.agreeDm;
    this.request.agreeInfo.agreeEmail = this.param.agreeInfo.agreeEmail;
    this.request.agreeInfo.agreeSms = this.param.agreeInfo.agreeSms;
    this.request.agreeInfo.agreeTel = this.param.agreeInfo.agreeTel;

    this.request.snsId = this.param.snsId;
    this.request.userInfo.userId = this.param.snsId;
    this.request.snsType = this.param.snsType;

    this.request.userInfo.birth = this.param.userInfo.birth;
    this.request.userInfo.cellNum = this.param.userInfo.cellNum;
    this.request.userInfo.sex = this.param.userInfo.sex;
    this.request.userInfo.sex = this.param.userInfo.sex;
    this.request.userInfo.userName = this.param.userInfo.userName;

    // 관심상품 리스트
    await ApiService.service('GET', 'common/commonItem/CUS1')
      .then(({ data }) => {
        // console.log(data);
        this.cus1Items = data.result[0].commonItems;
      })
      .catch(({ response }) => {
        console.log(response);
      });

    // 성별
    await ApiService.service('GET', 'common/code/RCSB')
      .then(({ data }) => {
        //console.log(data);
        this.cus2Items = data.result[0].codeList;
      })
      .catch(({ response }) => {
        console.log(response);
      });

    // 가족구성
    await ApiService.service('GET', 'common/commonItem/CUS3')
      .then(({ data }) => {
        // console.log(data);
        this.cus3Items = data.result[0].commonItems;
      })
      .catch(({ response }) => {
        console.log(response);
      });

    this.getUUID();
  },
  data() {
    return {
      uuid: '',
      selectedAgree3: null, // 선택동의 여부
      cus1Items: [], // 관심상품 화면출력 리스트
      cus2Items: [], // 성별 화면출력
      cus3Items: [], // 가족구성 화면출력
      products: [], // 선택정보
      familyTypes: [], // 가족구성 전체
      sex: null, // 성별
      family: null, // 가족구성
      pet: null, // 펫
      joinInfo: {}, // 회원가입 정보

      param: null,
      request: {
        agreeInfo: {
          agreeAppPush: '',
          agreeCollection: '',
          agreeCredit: '',
          agreeDm: '',
          agreeEmail: '',
          agreeSms: '',
          agreeTel: '',
        },
        familyTypes: [],
        prodGroupCodes: [],
        snsId: '',
        snsType: '',
        userInfo: {
          birth: '',
          cellNum: '',
          password: '',
          sex: '',
          userId: '',
          userName: '',
        },
      },
    };
  },
  computed: {
    cus3Items_first() {
      return this.cus3Items.slice(0, this.cus3Items.length - 1);
    },
    cus3Items_last() {
      return this.cus3Items.slice(this.cus3Items.length - 1);
    },
  },
  methods: {
    snsJoin() {
      if (this.family) this.familyTypes.push(this.family);
      if (this.pet) this.familyTypes.push(this.cus3Items_last[0].bsnId + this.cus3Items_last[0].bsnVal);

      this.request.familyTypes = this.familyTypes;
      this.request.prodGroupCodes = this.products;
      this.request.uuid = this.uuid;

      this.$refs.header.loadingStart();

      ApiService.service('POST', 'user/snsJoin', {
        request: this.request,
        serviceType: 'app',
      })
        .then(({ data }) => {
          console.log(data);
          if (data.isSucceed) {
            const params = {
              af_registration_method: 'SNS',
              af_used_rental: data.result.rentalUsedYn,
            };
            //const appsFlyerParams = JSON.stringify(params);
            window.appsFlyer('af_complete_registration', params);
            console.log(this.request);
            this.$router.push({
              name: 'snsJoinStep4',
              params: { couponInfo: data.result, request: this.request },
            });
          }
        })
        .catch(({ response }) => {
          console.log(response);
        });

      this.$refs.header.loadingEnd();
    },
    getUUID() {
      try {
        window.getUUID();
        setTimeout(
          function() {
            this.uuid = window.getUUIDValue();
            return this.uuid;
          }.bind(this),
          100,
        );
      } catch (e) {
        //console.err(e);
      }
    },
  },
};
</script>
